import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessDocument, DocumentListResponse } from "@/shared/types/api/business-mode.types"

const PAGE_SIZE = 50

interface BusinessDocumentListPageParam {
  offset: number
  limit: number
}

export const listBusinessDocumentsApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessDocumentsList"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      listBusinessDocuments: builder.infiniteQuery<
        { items: BusinessDocument[]; total: number },
        void,
        BusinessDocumentListPageParam
      >({
        infiniteQueryOptions: {
          initialPageParam: { offset: 0, limit: PAGE_SIZE },
          getNextPageParam: (lastPage, _allPages, lastPageParam) => {
            if (lastPage.items.length < lastPageParam.limit) {
              return undefined
            }
            return {
              offset: lastPageParam.offset + lastPageParam.limit,
              limit: lastPageParam.limit
            }
          }
        },
        query: ({ pageParam }) => ({
          url: "/api/v1/business/documents",
          params: {
            offset: pageParam.offset,
            limit: pageParam.limit
          }
        }),
        transformResponse: (response: DocumentListResponse) => ({
          items: response.documents,
          total: response.total
        }),
        providesTags: () => [{ type: "BusinessDocumentsList" as const }]
      })
    })
  })

export const { useListBusinessDocumentsInfiniteQuery } = listBusinessDocumentsApi

export const invalidateBusinessDocumentsList = () =>
  listBusinessDocumentsApi.util.invalidateTags([{ type: "BusinessDocumentsList" as const }])
